/** Merge a market batch in O(symbols + updates), retaining untouched objects. */
export function mergeTickerUpdates<T extends { s: string }>(
  current: T[],
  updates: T[],
): T[] {
  if (!updates.length) return current;
  const indexes = new Map<string, number>();
  current.forEach((ticker, index) => {
    if (!indexes.has(ticker.s)) indexes.set(ticker.s, index);
  });
  let result = current;
  updates.forEach(ticker => {
    const index = indexes.get(ticker.s);
    const previous = index === undefined ? undefined : result[index];
    if (
      previous &&
      Object.keys(previous).length === Object.keys(ticker).length &&
      Object.keys(ticker).every(
        key => previous[key as keyof T] === ticker[key as keyof T],
      )
    )
      return;
    if (result === current) result = current.slice();
    if (index === undefined) {
      indexes.set(ticker.s, result.length);
      result.push(ticker);
    } else result[index] = ticker;
  });
  return result;
}
